/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-group[_ngcontent-%COMP%]   div.dropdown-wrapper[_ngcontent-%COMP%]{left:0;margin-top:40px}"];
export { styles as styles };
